module.exports = __webpack_public_path__ + "static/media/exclamation.de9fb914.svg";